import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { IBackofficeDictionary } from 'domains/backoffice/interfaces/backoffice.interfaces.ts';
import { getBackofficeDictionaryService } from 'domains/backoffice/services/backoffice.service.ts';

const BACKOFFICE_DICTIONARY_REFRESH_INTERVAL = 30 * 1000;

export const useBackofficeDictionaryQuery = (
  token: string,
  options?: Omit<UseQueryOptions<IBackofficeDictionary>, 'queryKey' | 'queryFn'>,
): UseQueryResult<IBackofficeDictionary> =>
  useQuery({
    queryKey: ['backoffice-dictionary', token],
    queryFn: () => getBackofficeDictionaryService(token),
    staleTime: BACKOFFICE_DICTIONARY_REFRESH_INTERVAL,
    refetchInterval: BACKOFFICE_DICTIONARY_REFRESH_INTERVAL,
    gcTime: 30 * 60 * 1000,
    ...options,
  });
